import React from "react";
import { Layout } from "react-admin";
import Menu from "./Menu";

const KSLayout = (props) => <Layout {...props} menu={Menu} />;

export default KSLayout;
